// Base extensions shared by every CodeEditor instance: key bindings, selection
// behavior, syntax highlighting, theming, line wrapping, and read-only mode.
import { defaultKeymap } from "@codemirror/commands";
import { bracketMatching } from "@codemirror/language";
import { searchKeymap } from "@codemirror/search";
import { EditorState } from "@codemirror/state";
import {
  drawSelection,
  EditorView,
  highlightSpecialChars,
  keymap,
} from "@codemirror/view";
import { highlight } from "./highlight";
import { theme } from "./theme";

export default [
  highlightSpecialChars(),
  drawSelection(),
  keymap.of([...defaultKeymap, ...searchKeymap]),
  bracketMatching(),
  highlight,
  theme,
  EditorView.lineWrapping,
  EditorView.editable.of(false),
  EditorState.readOnly.of(true),
  EditorView.contentAttributes.of({ tabindex: "0" }),
];
